export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5609.40421f74.jpg";